<template>
  <div class="box-form">
    <Navbar />
    <div class="form">
      <b-container class="text-center space">
        <b-row class="justify-content-center">
          <b-col lg="5" md="7" align-self="center">
            <b-form @submit="addQuiz">
              <b-card img-src="KMPPARTNER7.jpg" img-top>
                <br />
                <b-card-text>
                  <b-row class="text-left mb-2">
                    <b-col lg="5">
                      ชื่อบริษัท
                      <span>*</span>
                    </b-col>
                    <b-col>
                      <b-form-input required v-model="form.name_company" size="sm"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="text-left mb-2">
                    <b-col lg="5">
                      ชื่อผู้ติดต่อ
                      <span>*</span>
                    </b-col>
                    <b-col>
                      <b-form-input required v-model="form.name_contact" size="sm"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="text-left mb-2">
                    <b-col lg="5">
                      เบอร์โทรศัพท์
                      <span>*</span>
                    </b-col>
                    <b-col>
                      <b-form-input required v-model="form.tel" size="sm"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="text-left mb-2">
                    <b-col lg="5">
                      เรื่องที่ต้องการติดต่อ
                      <span>*</span>
                    </b-col>
                    <b-col>
                      <b-form-select required v-model="form.detail" :options="options" size="sm"></b-form-select>
                    </b-col>
                  </b-row>
                </b-card-text>
                <b-button type="submit" class="mt-3" variant="primary">ส่งเเบบฟอร์ม</b-button>
              </b-card>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer />
  </div>
</template>
<script>
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import axios from "axios";
export default {
  components: {
    Navbar: Navbar,
    Footer: Footer
  },
  data() {
    return {
      form: {
        name_company: null,
        name_contact: null,
        tel: null,
        detail: null
      },
      options: [
        {
          value: "ต้องการทราบรายละเอียดการขอสินเชื่อ",
          text: "ต้องการทราบรายละเอียดการขอสินเชื่อ"
        },
        { value: "ติดตามสถานะการขอสินเชื่อ", text: "ติดตามสถานะการขอสินเชื่อ" },
        { value: "ติดตามเอกสาร", text: "ติดตามเอกสาร" },
        {
          value: "ต้องการนัดวันเวลาเพื่อเข้ามาทำธุรกรรมหรือเซ็นสัญญา",
          text: "ต้องการนัดวันเวลาเพื่อเข้ามาทำธุรกรรมหรือเซ็นสัญญา"
        }
      ]
    };
  },
  methods: {
    addQuiz: function(e) {
      e.preventDefault();
      this.$bvModal
        .msgBoxConfirm("กรุณายืนยันที่จะส่งแบบฟอร์ม", {
          title: "ยืนยัน?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          footerClass: "p-1",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            axios
              .post("http://165.22.250.134:5004/api/form/add", this.form)
              .then(res => {
                if (res.data.status) {
                  this.$bvModal
                    .msgBoxOk("ส่งเเบบฟอร์มเรียบร้อยเเล้ว", {
                      title: "สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "success",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง"
                    })
                    .then(values => {
                      if (values) {
                        axios.post('http://165.22.250.134:5004/api/form/notify',this.form).then(rest => {
                          if (rest.data.statusNotify) {
                            location.reload();
                          } else {
                            this.$bvModal
                              .msgBoxOk("กรุณาลองใหม่อีกครั้ง", {
                                title: "ผิดพลาด",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "danger",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                                okTitle: "ตกลง"
                              })
                              .then(values => {
                                if (values) {
                                  location.reload();
                                }
                              });
                          }
                        });
                      }
                    });
                } else {
                  this.$bvModal
                    .msgBoxOk(res.data.error, {
                      title: "ผิดพลาด ลองใหม่อีกครั้ง",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "danger",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง"
                    })
                    .then(values => {
                      if (values) {
                        location.reload();
                      }
                    });
                }
              });
          }
        });
    }
  }
};
</script>
<style>
span {
  color: red;
}
.box-form {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.form {
  margin: 2% !important;
  margin-bottom: 6% !important;
}
@media (max-width: 600px) {
  .form {
    margin-top: 8% !important;
    margin-bottom: 20% !important;
  }
}
.card-body {
  padding-top: 0px !important;
}
</style>